import { useLanguage } from "@/hooks/useLanguage";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Link } from "react-router-dom";

const About = () => {
  const { t } = useLanguage();
  const titleAnimation = useScrollAnimation();
  const contentAnimation = useScrollAnimation();
  const imageAnimation = useScrollAnimation();

  return (
    <section className="py-8 sm:py-12 md:py-16 lg:py-20 bg-gradient-to-br from-background via-muted/20 to-background relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent animate-fade-in-down"></div>
      <div className="absolute -top-32 sm:-top-40 -right-32 sm:-right-40 w-64 h-64 sm:w-80 sm:h-80 bg-primary/5 rounded-full blur-3xl animate-float"></div>
      <div className="absolute -bottom-32 sm:-bottom-40 -left-32 sm:-left-40 w-64 h-64 sm:w-80 sm:h-80 bg-secondary/5 rounded-full blur-3xl animate-float" style={{ animationDelay: '1.5s' }}></div>
      
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          
          {/* Brand Overview */}
          <div className="text-center max-w-4xl mx-auto">
            <div 
              ref={contentAnimation.ref as any}
              className={`space-y-4 sm:space-y-6 md:space-y-8 ${contentAnimation.isVisible ? 'animate-fade-in-up' : 'opacity-100'}`}
            >
              <div className="space-y-3 sm:space-y-4 md:space-y-6">
                <p className="text-xs sm:text-sm md:text-base font-medium text-primary tracking-wider uppercase">
                  About Brassbell
                </p>
                <h2 
                  ref={titleAnimation.ref as any}
                  className={`text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-light leading-tight text-foreground ${titleAnimation.isVisible ? 'animate-fade-in-up' : 'opacity-100'}`}
                >
                  A House of Brands, Curating Hospitality Concepts That Redefine Travel, Living, and Community
                </h2>
              </div>
              <p className="text-xs sm:text-sm md:text-base lg:text-lg font-light text-muted-foreground leading-relaxed max-w-3xl mx-auto">
                Brassbell Hospitality Group (BHG) is a next-generation hospitality and real estate platform that develops, operates, and invests in transformative destinations. Our dual expertise as both developers and operators enables us to control the entire value chain — from concept creation and asset development to long-term operations and brand stewardship.
              </p>
              <div className="flex justify-center pt-2 sm:pt-4">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg transition-all duration-300 font-medium hover-lift hover-glow group text-xs sm:text-sm md:text-base"
                >
                  Learn More About Brassbell Hospitality Group
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;